module.exports = __webpack_public_path__ + "img/nnk.ac09c04e.jpeg";